import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";

export default function Layout({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const isSecretaria = loc.pathname.startsWith("/secretaria");
  return (
    <div className="min-h-screen flex flex-col bg-cream-100">
      <Header />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      {!isAdmin && !isSecretaria && <ChatWidget />}
    </div>
  );
}
